import "./sections";
import "./admin-dialog-shell.component";

import "./create-campaign-dialog.component";
import "./create-organisation-dialog.component";
import "./edit-campaign-dialog.component";
import "./campaign-subscription-dialog.component";
import "./xero-invoices-dialog.component";
import "./campaign-charge-dialog.component";
import "./admin-prospector-dialog.component";
import "./admin-export-dialog.component";
import "./admin-activity-dialog.component";
import "./admin-org-accounts-dialog.component";
